import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from 'src/app/store/core/url/customizeHttpUrlGenerator';
import { MedicalSterilizationModel } from '../../../api/entity/medicalSterilization.model';
import { MedicalSterilizationConverter } from '../../../api/entity/converter/medicalSterilization.converter';

@Injectable({
  providedIn: 'root'
})
export class MedicalSterilizationDataService extends AbstractDataServiceV2<MedicalSterilizationModel, MedicalSterilizationConverter> {
  constructor(http: HttpClient,
              httpUrlGenerator: CustomizeHttpUrlGenerator,
              logger: Logger,
              config: DefaultDataServiceConfig,
              converter: MedicalSterilizationConverter) {
    super('MedicalSterilization', http, httpUrlGenerator, logger, config, converter);
  }
}

